import CheckoutForm from "./CheckoutForm/CheckoutForm";
import { CheckoutUIProvider } from "./CheckoutUIProvider";

const CheckoutFlow = () => {
  return (
    <CheckoutUIProvider>
      <CheckoutForm />
    </CheckoutUIProvider>
  );
};

export default CheckoutFlow;
